/**
 * Admin = instalación (GEN-PX-017). El submenú de Admin son las entradas de instalación que el kernel ya emite, solo al
 * administrador, como ítems del menú (R-PT-02/R-PT-04): el kernel decide quién las tiene y el front solo las ordena y las pinta.
 * Una entrada que el kernel no emita no sale. Ocultar es cosmético: la puerta real es la de cada endpoint.
 * Lo que tiene sitio propio (Personas, Agentes, Normas, Auditoría) no está aquí.
 */

// El orden es el del submenú; `texto` es la etiqueta de la pestaña.
export const PESTANAS_ADMIN = [
  { id: 'herramientas', texto: 'Herramientas' },
  { id: 'modelos', texto: 'Modelos' },
  { id: 'libro-de-estilo', texto: 'Marca y estilo' },
  { id: 'coste', texto: 'Coste' },
  { id: 'salud', texto: 'Salud' },
]

/** Pestañas de Admin que el menú del kernel permite, en orden. */
export function pestanasAdmin(menu = []) {
  const usable = id => menu.some(m => m && m.id === id && m.visible && m.enabled)
  return PESTANAS_ADMIN.filter(p => usable(p.id))
}
